export default __webpack_public_path__ + "static/media/man-3123561_1920.56575ad9.jpg";